// TODO: add ability to proxy requests to stages

// eslint-disable-next-line no-undef
export const fetcher = <T>(input: string, init?: RequestInit): Promise<T> =>
  fetch(input, init).then((res) => res.json());
